/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ILanguagePickerViewProps } from './cip-language-picker';

/**
 * Address Add Update Component.
 * @param param0 - Root param.
 * @param param0.AddressForm - Address form.
 * @param param0.availableLanguages - Cancel button.
 * @returns - AddressForm Node.
 */
const LanguagePickerNode: React.FC<any> = ({ availableLanguages }) => {
    return <Node className=''>{availableLanguages}</Node>;
};

/**
 * Business Account Address View Component.
 * @param props - Props.
 * @returns - LanguagePicker Module.
 */
const cipLanguagePickerView: React.FC<ILanguagePickerViewProps> = props => {
    const { LanguagePicker, availableLanguages } = props;

    return (
        <Module {...LanguagePicker}>
            <LanguagePickerNode availableLanguages={availableLanguages} />
        </Module>
    );
};

export default cipLanguagePickerView;
